export class UsersTable {
  public static users: any = [
    {
      id: 1,
      name: 'admin',
      password: 'revilo',
      email: 'oliver@oliver.com',
      access_token: 'access-token-8f3ae836da744329a6f93bf20594b5cc',
      refresh_token: 'access-token-f8c137a2c98743f48b643e71161d90aa'
    },
    {
      id: 2,
      name: 'user',
      password: 'demo',
      email: 'user@demo.com',
      access_token: 'access-token-6829bba69dd3421d8762-991e9e806dbf',
      refresh_token: 'access-token-f8e4c61a318e4d618b6c199ef96b9e55',
    }
  ];

  public static tokens: any = [
    {
      id: 1,
      access_token: 'access-token-' + Math.random(),
      refresh_token: 'access-token-' + Math.random(),
    },
  ];
}
